<div
    class="d-flex align-items-center justify-content-center"
    style="position: fixed; inset: 0; background-color: #f5f7fa; z-index: 1050; overflow-y: auto"
>
    <div class="text-center p-5" style="max-width: 520px">
        <h2 style="color: #1a5276; font-weight: bold; margin-bottom: 24px">VanCon Inc.</h2>

        @if (status === 'loading') {
            <div class="spinner-border text-primary mb-3" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <p class="text-muted">Processing your request&hellip;</p>
        }

        @if (status === 'success') {
            <div
                class="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                style="width: 72px; height: 72px; background-color: #d4efdf"
            >
                <span style="font-size: 36px; color: #27ae60">&#10003;</span>
            </div>
            <h4 class="mb-3">Thank You!</h4>
            <p>This punch list item has been marked as complete.</p>

            @if (commentStatus === 'idle' || commentStatus === 'error') {
                <div class="text-start mt-4" style="background: #fff; border-radius: 8px; padding: 20px">
                    <label for="completionComment" class="form-label text-muted" style="font-size: 0.9em">
                        Optionally, leave a comment about this item:
                    </label>
                    <textarea
                        id="completionComment"
                        class="form-control mb-3"
                        rows="3"
                        [(ngModel)]="comment"
                        name="completionComment"
                        placeholder="Enter any notes or details here..."
                    ></textarea>
                    @if (commentStatus === 'error') {
                        <p class="text-danger mb-2" style="font-size: 0.85em">
                            Failed to save your comment. Please try again.
                        </p>
                    }
                    <button
                        type="button"
                        class="btn btn-primary btn-sm"
                        (click)="submitComment()"
                        [disabled]="!comment.trim()"
                    >
                        Submit Comment
                    </button>
                </div>
            }

            @if (commentStatus === 'submitting') {
                <div class="mt-4">
                    <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                    Saving your comment&hellip;
                </div>
            }

            @if (commentStatus === 'submitted') {
                <p class="text-success mt-4" style="font-size: 0.95em">Your comment has been saved. Thank you!</p>
            }

            <p class="text-muted mt-3" style="font-size: 0.9em">You may close this page. No further action is needed.</p>
        }

        @if (status === 'error') {
            <div
                class="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                style="width: 72px; height: 72px; background-color: #fadbd8"
            >
                <span style="font-size: 36px; color: #c0392b">&#10007;</span>
            </div>
            <h4 class="mb-3">Unable to Process</h4>
            <p>This link is no longer valid or the item was not found.</p>
            <p class="text-muted" style="font-size: 0.9em">
                If you believe this is an error, please contact your VanCon project representative.
            </p>
        }
    </div>
</div>
